var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.31,
    height: 21.31,
    viewBox: "0 0 21.31 21.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_393",
    "data-name": "Ret\\xE2ngulo 393",
    width: 21.31,
    height: 21.31,
    transform: "translate(0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    "data-name": "Caminho 2",
    d: "M44.748,19.285A12.32,12.32,0,0,0,57.179,6.854V6.262A9.623,9.623,0,0,0,59.31,4.013a9.827,9.827,0,0,1-2.486.71,4.606,4.606,0,0,0,1.894-2.368,10.859,10.859,0,0,1-2.723,1.065A4.228,4.228,0,0,0,52.8,2a4.448,4.448,0,0,0-4.38,4.38,2.308,2.308,0,0,0,.118.947,12.24,12.24,0,0,1-9-4.617,4.534,4.534,0,0,0-.592,2.249,4.7,4.7,0,0,0,1.894,3.67,3.991,3.991,0,0,1-2.013-.592h0A4.327,4.327,0,0,0,42.38,12.3a3.65,3.65,0,0,1-1.184.118,2.015,2.015,0,0,1-.829-.118,4.485,4.485,0,0,0,4.144,3.078,8.938,8.938,0,0,1-5.446,1.894A3.278,3.278,0,0,1,38,17.154a11.174,11.174,0,0,0,6.748,2.131",
    transform: "translate(-38 0.663)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.021e1a67564eb40daef3a7bf6962ad57.svg";
export { ForwardRef as ReactComponent };